export const appHomePage = '/find-a-pro';

export const localStorageKeys = {
  geoData: '_ct_app_fap_geo',
  productCategory: '_ct_app_fap_prod_category',
  contractorsTray: '_ct_app_fap_contractors_tray',
  savedFilters: '_ct_app_fap_saved_filters',
};

export const defaultRadius = 40234;

export const maxRadius = 160934;

export const facets = [
  'field_agent_services',
  'certifications',
  'field_agent_type',
];

export const maxSelectedContractors = 3;

export const agentTypesMap = {
  contractor: 633,
};

export const initialFiltersState = {
  // String in formal 'lat, lng'.
  location: '',
  // Radius in meters.
  radius: defaultRadius,
  field_agent_services: [],
  certifications: [],
  page: 0,
  hitsPerPage: 8,
};

export const searchRadiuses = [40234, 80467, 120701, 160934];
